import React, { PropsWithChildren } from 'react'

import * as S from './styles'

export type PopoverProps = PropsWithChildren<{
  /**
   * Vertical position of the popover
   *
   * @example
   * ```tsx
   * <Popover verticalAlign="top" />
   * ```
   *
   * @default 'bottom'
   *
   */
  verticalAlign?: 'top' | 'bottom' | 'center'

  /**
   * Horizontal position of the popover
   *
   * @example
   * ```tsx
   * <Popover horizontalAlign="left" />
   * ```
   *
   * @default 'left'
   *
   */
  horizontalAlign?: 'left' | 'right' | 'center'

  /**
   * Class name of the popover
   *
   * @example
   * ```tsx
   * <Popover className="popover" />
   * ```
   *
   */
  className?: string
}>

export const Popover: React.FC<PopoverProps> = ({
  verticalAlign,
  horizontalAlign,
  className,
  children,
}) => (
  <S.Card
    verticalAlign={verticalAlign}
    horizontalAlign={horizontalAlign}
    className={className}
  >
    {children}
  </S.Card>
)
